import { useMutation } from '@tanstack/react-query';
import type { CandidateProfileDeleteRequest } from '../types/CandidateProfile';

export default function useDeleteCandidateProfile() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ candidateProfileId }: CandidateProfileDeleteRequest) => {
      const response = await fetch(`/agent/api/candidate_profiles/${candidateProfileId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({}),
      });
      const data = await response.json();
      return data;
    },
  });
}
